import { request } from './request';

export default {
  /**
   * 订单列表
   */
  getOrderBase(Unit) {
    return request({
      url: '/order/getOrderBase',
      method: 'post',
      params: {
        Unit,
      },
    });
  },
  /**
   * 合同列表
   */
  GetReportContractList(search) {
    return request({
      url: '/order/GetReportContractList',
      method: 'post',
      data: search,
    });
  },
  /**
   * 订单列表
   */
  getOrderList(search) {
    return request({
      url: '/order/getOrderList',
      method: 'post',
      data: search,
    });
  },
  /**
   * 生成订单
   * @returns order,orderSalesTeam
   */
  createOrder() {
    return request({
      url: '/Order/CreateOrder',
      method: 'post',
      data: {},
    });
  },
  /**
   * 获取订单
   * @param {String} orderNumber
   * @returns
   */
  getOrderByOrderNo(OrderNumber) {
    return request({
      url: '/Order/getOrderByOrderNo',
      method: 'get',
      params: {
        OrderNumber,
      },
    });
  },
  /**
   * 获取订单
   * @param {Number} Id
   * @returns
   */
  getOrder: function (Id) {
    return request({
      url: `/Order/${Id}`,
      method: 'get',
      params: {},
    });
  },
  /**
   * 订单信息
   * @param {String} OrderNumber
   * @returns
   */
  getOrderInfo: function (OrderNumber, Unit) {
    return request({
      url: `/Order/getOrderInfo`,
      method: 'get',
      params: {
        OrderNumber,
        Unit,
      },
    });
  },
  /**
   * 销售修改记录
   * @param {String} OrderId
   * @returns
   */
  getOrderChangeRecords: function (OrderId) {
    return request({
      url: `/Order/getOrderChangeRecords`,
      method: 'get',
      params: {
        OrderId,
      },
    });
  },
  /**
   * 订单主要信息
   * @param {Number} Id
   * @returns
   */
  getOrderMaster(OrderNo, OrderId) {
    return request({
      url: '/order/getOrderMaster',
      method: 'get',
      params: {
        OrderNo,
        OrderId,
      },
    });
  },
  /**
   * 更新订单信息
   * @param {Object} Order
   * @returns
   */
  changeOrder: function (Order) {
    return request({
      url: '/order/changeOrder',
      method: 'post',
      data: Order,
    });
  },
  /**
   * 广告商存在其他订单中
   * @param {*} CustomerCode
   * @returns
   */
  existOrderForAdvertiser: function (AdvertiserCode, OrderId) {
    return request({
      url: '/order/existOrderForAdvertiser',
      method: 'get',
      params: {
        AdvertiserCode,
        OrderId,
      },
    });
  },
  /**
   * 保存/创建订单
   * @param {*} Order
   */
  saveOrder(Order) {
    return request({
      url: '/order/SaveOrder',
      method: 'post',
      data: Order,
    });
  },
  /**
   * 保存/创建订单
   * @param {*} Order
   */
  saveOrderInfo(Order) {
    return request({
      url: '/order/SaveOrderInfo',
      method: 'post',
      data: Order,
    });
  },
  /**
   * 获取订单销售员工信息
   * @param {int} Id
   * @returns
   */
  getOrderSalesTeam: function (Id) {
    return request({
      url: '/Order/getOrderSalesTeam',
      method: 'get',
      param: {
        Id,
      },
    });
  },
  /**
   * 订单销售员信息
   * @param {int} OrderId 订单Id
   * @param {String} SalesmanCode 销售员Code
   * @returns
   */
  getOrderSalesman: function (OrderId) {
    return request({
      url: '/Order/getOrderSalesman',
      method: 'get',
      params: {
        OrderId,
      },
    });
  },
  /**
   * 根据订单Id获取订单销售员信息
   * @param {int} OrderId
   * @returns
   */
  getOrderSalesTeamGroupByOrderId: function (OrderId) {
    return request({
      url: '/Order/getOrderSalesTeamGroupByOrderId',
      type: 'get',
      params: {
        OrderId,
      },
    });
  },
  /**
   * 变更订单销售员信息和记录
   * @param {Object} Record 销售员记录信息
   * @param {String} SalesmanCode 销售员Code
   */
  changeOrderSalesTeamAndRecord(Record) {
    return request({
      url: '/Order/changeOrderSalesTeamAndRecord',
      method: 'post',
      data: Record,
    });
  },
  /**
   * 获取订单销售员变更记录
   * @param {int} OrderId
   */
  getOrderSalesRecords: function (OrderId) {
    return request({
      url: `/Order/getOrderSalesRecords/${OrderId}`,
      type: 'get',
    });
  },
  /**
   * 获取订单基本信息
   * @param {number} Id
   */
  getOrderBasicInfo: function (Id) {
    const promise = new Promise((resolve) => {
      const basicinfo = localStorage.getItem('OrderBasicInfo_' + Id);

      if (basicinfo === null) {
        return resolve({});
      }

      const OrderBasicInfo = JSON.parse(
        localStorage.getItem('OrderBasicInfo_' + Id)
      );

      return resolve(OrderBasicInfo);
    });

    return promise;
  },
  /**
   * 更新订单基本信息
   * @param {Object} BasicInfo
   */
  changeOrderBasicInfo: function (BasicInfo) {
    const promise = new Promise((resolve) => {
      const { Id } = BasicInfo;
      localStorage.setItem('OrderBasicInfo_' + Id, JSON.stringify(BasicInfo));

      return resolve({
        Msg: 'OK',
      });
    });
    return promise;
  },
  /**
   * 销售联系人列表
   * @param {Number} OrderId 订单Id
   */
  getOrderContacts: function (OrderId) {
    return request({
      url: '/Order/GetOrderContactPersons',
      method: 'get',
      params: {
        OrderId,
      },
    });
  },
  /**
   * 批量更新订单联系人
   * @param {Array} Contacts 联系人信息
   */
  changeOrderContacts: function (Contacts) {
    return request({
      url: '/order/changeOrderContacts',
      method: 'post',
      data: Contacts,
    });
  },
  /**
   * 删除订单联系人
   * @param {Number} id
   */
  deleteOrderContact(id) {
    return request({
      url: '/Order/Contact/' + id,
      method: 'delete',
    });
  },
  /**
   * 订单行业分类列表
   * @param {String} OrderId
   */
  getOrderBusinessCategroies(OrderId) {
    return request({
      url: '/Order/GetOrderBusinessCategories',
      method: 'get',
      params: {
        OrderId,
      },
    });
  },
  /**
   * 批量更新订单行业分类
   * @param {Array} businesses
   * @returns
   */
  changeOrderBusinessCategroies(businesses) {
    return request({
      url: '/Order/changeOrderBusinessCategories',
      method: 'post',
      data: businesses,
    });
  },
  /**
   * 合同视图列表
   * @param {Number} OrderId
   * @returns
   */
  getContracts(OrderId) {
    return request({
      url: '/contract/getContractsByOrderId',
      method: 'get',
      params: {
        OrderId,
      },
    });
  },
  /**
   * 订单产品信息
   * @param {*} orderId
   */
  getOrderProduct(orderId) {
    return request({
      url: '/order/getOrderProduct/' + orderId,
      method: 'get',
    });
  },
  /**
   * 更新订单产品
   * @param {Object} orderProduct
   * @returns
   */
  changeOrderProductName(orderProduct) {
    return request({
      url: '/Order/changeOrderProductName',
      method: 'post',
      data: orderProduct,
    });
  },
  /**
   * 批量更新订单产品分类
   * @param {Array} orderProductCategories
   */
  changeOrderProductCategories(orderProductCategories) {
    return request({
      url: '/Order/changeOrderProductCategories',
      method: 'post',
      data: orderProductCategories,
    });
  },
  /**
   * 删除订单产品分类
   * @param {Number} id
   */
  deleteOrderProductCategory(id) {
    return request({
      url: '/Order/deleteOrderProductCategory',
      method: 'post',
      params: {
        id,
      },
    });
  },
  /**
   * 保存Product
   * @param {Object} Product
   */
  saveOrderProduct(Product) {
    return request({
      url: '/order/SaveOrderProduct',
      method: 'post',
      data: Product,
    });
  },
  /**
   * 修改ProductionName
   * @param {Object} Product
   */
  UpdateProductName(orderId, productName) {
    return request({
      url: '/order/UpdateProductName',
      method: 'post',
      data: { orderId: orderId, productName: productName },
    });
  },
  /**
   * Salesman 建议列表
   */
  getSalesmanSuggests() {
    return request({
      url: '/order/getSalesmanSuggests',
      method: 'get',
    });
  },
  /**
   * Salesman 建议列表
   */
  getSalesOption(Unit) {
    return request({
      url: '/order/getSalesOption',
      method: 'get',
      params: {
        id: Unit.id,
        alias: Unit.alias,
        name: Unit.name,
      },
    });
  },
  /**
   * 重计Internal Split
   * @param {Object} CalculateSplit
   */
  ReCalculateInternalSplit(OrderId, IsAgencyDiscount, AgencyDiscount) {
    return request({
      url: '/order/ReCalculateInternalSplit',
      method: 'post',
      params: {
        OrderId,
        IsAgencyDiscount,
        AgencyDiscount,
      },
    });
  },
  /**
   * 获取订单中的销售员列表
   * @returns
   */
  GetOrderSalesmanList() {
    return request({
      url: '/Order/GetOrderSalesmanList',
      method: 'get',
    });
  },
  /**
   * 获取订单中的Advertiser列表
   * @returns
   */
  GetOrderContractingPartyList() {
    return request({
      url: '/Order/GetOrderContractingPartyList',
      method: 'get',
    });
  },
  /**
   * 作废订单
   * @param {Number} OrderId 订单Id
   * @param {String} remark 作废说明
   * @returns
   */
  VoidOrder(OrderId, remark) {
    return request({
      url: '/Order/VoidOrder',
      method: 'post',
      params: {
        OrderId,
        remark,
      },
    });
  },
  /**
   * GetMyTaskList
   */
  GetMyTaskList(search) {
    return request({
      url: '/order/GetMyTaskList',
      method: 'post',
      data: search,
    });
  },
  /**
   * 下载order Word
   */
  DwonloadJobOrderWord(OrderId, OrderNo, AgreementNo, ContractIds) {
    return request({
      url: '/order/DwonloadJobOrderWord',
      method: 'get',
      params: {
        OrderId,
        AgreementNo,
        ContractIds,
        OrderNo,
      },
      responseType: 'blob',
    });
  },
  /**
   * Contract List by Item
   */
  GetContractListByItemList(search) {
    return request({
      url: '/order/GetContractListByItemList',
      method: 'post',
      data: search,
    });
  },
  /**
   * 更新日期
   * @param {*} OrderId
   * @returns
   */
  UpdateDate(OrderId) {
    return request({
      url: '/order/UpdateOrderDate',
      method: 'post',
      params: { OrderId },
    });
  },
};
